import { render } from "./StudentsModal.vue?vue&type=template&id=189d9194&scoped=true"
import script from "./StudentsModal.vue?vue&type=script&lang=js"
export * from "./StudentsModal.vue?vue&type=script&lang=js"

import "./StudentsModal.vue?vue&type=style&index=0&id=189d9194&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189d9194"]])

export default __exports__